




import { disableScroll, enableScroll } from "@/frontend/lib/scrollUtils";
import { firstOperationRequested } from "./apollo";
import { hideMainSpinner, sleep } from "./lib/utils";
import { mapActions, mapState } from "vuex";
import Vue from "vue";
// import error from "@/frontend/mixins/error";
export default Vue.extend({
  // mixins: [error],
  computed: {
    ...mapState(["title", "metaDescription", "metaKeyword"]),
  },
  watch: {
    title(title) {
      this.setTitle(title);
    },
    metaDescription(description) {
      this.setMetaDescription(description);
    },
    metaKeyword(keyword) {
      this.setMetaKeyword(keyword);
    },
  },
  async mounted() {
    this.setTitle(this.title);
    this.setMetaDescription(this.metaDescription);
    this.setMetaKeyword(this.metaKeyword);

    addEventListener("resize", () => {
      this.setInnerSize();
    });
    this.setInnerSize();

    const mutationObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (document.body.classList.contains("el-popup-parent--hidden")) {
          disableScroll();
        } else {
          enableScroll();
        }
      });
    });

    mutationObserver.observe(document.body, {
      attributes: true,
      characterData: false,
      childList: false,
      subtree: false,
      attributeOldValue: false,
      characterDataOldValue: false,
    });

    await this.fetchLocalUserProfile();

    this.checkSpinnerTimeout();
  },
  methods: {
    ...mapActions(["fetchLocalUserProfile"]),
    setInnerSize() {
      const bodyEl = document.querySelector("body");
      if (bodyEl) {
        const size = `${window.innerHeight}px`;
        bodyEl.style.setProperty("--inner-height", size);
      }
    },
    setTitle(title) {
      document.title = title && title.length > 0 ? `${title}` : "DiSEL";
    },
    setMetaDescription(description) {
      const metaDescription: any = document.querySelector(
        "meta[name=description]",
      );
      if (metaDescription) {
        metaDescription.content = description;
      }
    },
    setMetaKeyword(keyword) {
      const metaKeyword: any = document.querySelector("meta[name=keyword]");
      if (metaKeyword) {
        metaKeyword.content = keyword;
      }
    },
    async checkSpinnerTimeout() {
      await sleep(300);
      hideMainSpinner();
      console.log("app fOppReq", firstOperationRequested);
    },
  },
});
